import React from 'react';
import { Box } from '@wix/design-system';
import s from './TrustBuilderBanner.scss';
export const TrustBuilderBanner = ({ children }) => {
    return (React.createElement(Box, { width: "100%", direction: "horizontal", verticalAlign: "middle" }, React.Children.map(children, (child) => (React.createElement(Box, { className: s.singleElementWrapper },
        React.createElement(Box, { className: s.singleElement }, child))))));
};
//# sourceMappingURL=TrustBuilderBanner.js.map